import React from "react"
import { inject, observer } from "mobx-react"

import LabeledSimpleInput from "~/components/Form/LabeledSimpleInput"
import NotchedField from "~/components/parking/_design/NotchedField"

const INPUT_FIELD_KEY = "name"

@inject(all => ({
  user: all.store.auth.user
}))
@observer
class FullName extends React.Component {
  handleChange = event => {
    // Get the string with no leading or middle whitespace
    const input = event.target.value.trimStart().replace(/\s{2,}/gm, " ")

    const formatted = []
    let lastCharacter = null;

    // If it's the first character, or a character after a space, capitalize it
    Array.from(input).forEach((character, index) => {
      if (index === 0 || lastCharacter === " ") formatted.push(character.toUpperCase())
      else formatted.push(character)
      lastCharacter = character
    })

    // Remove trailing whitespace 
    if (lastCharacter === " " && formatted.slice(0, -1).includes(" ")) formatted.pop()

    // Save the joined string on the currentInput state
    this.props.user.changeKey(INPUT_FIELD_KEY, formatted.join(""))
  }

  render() {
    const { disabled, user, notched } = this.props
    const errorMessage = user.validateDisplayMessage(INPUT_FIELD_KEY)

    if (notched) {
      return (
        <NotchedField
          id="fullName"
          name="fullName"
          label="First and Last Name"
          placeholder="John Doe"
          value={user[INPUT_FIELD_KEY]}
          onChange={this.handleChange}
          error={errorMessage}
          disabled={disabled}
        />
      )
    }

    return (
      <LabeledSimpleInput
        id="fullName"
        name="fullName"
        label="First and Last Name"
        placeholder="John Doe"
        value={user[INPUT_FIELD_KEY]}
        onChange={this.handleChange}
        error={errorMessage}
        disabled={disabled}
      />
    )
  }
}

export default FullName